<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="(size*15)/23"
    viewBox="0 0 23 15"
  ><g><g><g><g><g><path
    :fill="color"
    d="M21.562 12.656c0 .776-.63 1.406-1.406 1.406H2.344c-.776 0-1.407-.63-1.407-1.406V2.344c0-.776.631-1.406 1.407-1.406h17.812c.776 0 1.406.63 1.406 1.406v10.312zM20.156 0H2.344A2.347 2.347 0 0 0 0 2.344v10.312A2.347 2.347 0 0 0 2.344 15h17.812a2.347 2.347 0 0 0 2.344-2.344V2.344A2.347 2.347 0 0 0 20.156 0z"
  /></g></g></g><g><g><g><path
    :fill="color"
    d="M.937 5.625V3.75h20.625v1.875zm21.094-2.813H.47a.469.469 0 0 0-.469.47v2.812c0 .259.21.469.469.469H22.03c.259 0 .469-.21.469-.47V3.282a.469.469 0 0 0-.469-.469z"
  /></g></g></g><g><g><g><path
    :fill="color"
    d="M8.906 9.375H3.281a.469.469 0 0 0 0 .938h5.625a.469.469 0 0 0 0-.938z"
  /></g></g></g><g><g><g><path
    :fill="color"
    d="M8.906 11.25H3.281a.469.469 0 0 0 0 .938h5.625a.469.469 0 0 0 0-.938z"
  /></g></g></g><g><g><g><path
    :fill="color"
    d="M18.75 10.781c0 .259-.21.469-.469.469h-.937a.469.469 0 0 1-.469-.469v-.937c0-.259.21-.469.469-.469h.937c.259 0 .469.21.469.469zm-.469-2.344h-.937c-.776 0-1.407.631-1.407 1.407v.937c0 .776.631 1.406 1.407 1.406h.937c.776 0 1.406-.63 1.406-1.406v-.937c0-.776-.63-1.407-1.406-1.407z"
  /></g></g></g></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
